export default __webpack_public_path__ + "static/media/BackgroundGetKahshCardVisa.3d849a9b.png";